import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { environment } from "@environments";
import { Labels } from "@serasa/shared/labels";
import { InteractivityService } from "@serasa/shared/services/interactivity.service";
import { RenovateService } from "@serasa/shared/services/renovate.service";
import { Utils } from "@serasa/shared/utils/utils";
import {
  SedsBasicButtonModule,
  SedsModalAbstractComponent,
  SedsModalModule,
  SedsOutlinedButtonModule,
} from "@serasa/shared/seds";
import {
  CountdownComponent,
  CountdownEvent,
  CountdownModule,
  CountdownStatus,
} from "ngx-countdown";

@Component({
  templateUrl: "user-idle-modal.component.html",
  styleUrls: ["../../../styles/theme/modal.scss"],
  imports: [
    CountdownModule,
    SedsBasicButtonModule,
    SedsOutlinedButtonModule,
    SedsModalModule,
  ],
})
export class UserIdleModalComponent
  extends SedsModalAbstractComponent
  implements OnInit, OnDestroy
{
  public leftTimeInSeconds = 120;
  public labels = new Labels().userIdle.modal;
  public Utils = Utils;
  public openIdleUserModal = false;

  private _myCountdownTimer?: ReturnType<typeof setTimeout>;

  @ViewChild("countdown", { static: false })
  private myCountdown?: CountdownComponent;

  constructor(
    private readonly _interactivityService: InteractivityService,
    private readonly _renovateService: RenovateService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this._myCountdownTimer = setTimeout(() => {
      this.myCountdown?.restart();
      this.myCountdown?.begin();
    }, 100);
  }

  public goToHomePage(): void {
    this._closeUserIdleModal();
    this.myCountdown?.pause();
    this.Utils.doLogout();

    window.location.href = environment.productMenuMainURL;
  }

  public resetModalTimer(): void {
    const milisecondsToShowModal =
      Number.parseInt(localStorage.getItem("milisecondsToShowModal") || "") ||
      13 * 60 * 1000;

    this._interactivityService.setupInactivityTimer(milisecondsToShowModal);
    this._closeUserIdleModal();
    this._interactivityService.hasModalOpened = false;
  }

  public handleEvent(event: CountdownEvent): void {
    if (event.status === CountdownStatus.done) {
      this._renovateService.renovateErrorSubject.next(
        new HttpErrorResponse({
          error: "The expiring time is over.",
          url: window.location.href,
        }),
      );

      this._closeUserIdleModal();
      this.Utils.doLogout();
    }
  }

  private _closeUserIdleModal(): void {
    this.close();
  }

  ngOnDestroy(): void {
    clearTimeout(this._myCountdownTimer);
  }
}
